<div class="row">
  <div class="col-12">
    <label for="disp-testedpartyname">Tested Party Name</label>
    <span class="actualdata">{{ studyVM.study.testedPartyName }}</span>
  </div>
</div>

<div class="row" *ngIf="studyVM.isWorldRegionsEnabledOnTestedParty">
  <div class="col-12">
    <label for="region-country">World regions (geographical)</label>
    <p-tree [value]="displayTestedPartyRegionCountry"></p-tree>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <label for="disp-function">Function Type</label>
    <span class="actualdata">{{ studyVM.FunctionText }}</span>
  </div>
</div>
<hr />
<div class="title">Industries and Sectors</div>
<div class="row">
  <div class="col-6">
    <label for="disp-industry">Industry and Sector</label>
    <span class="actualdata">{{ studyVM.IndustryText }}</span>
  </div>

  <div class="col-6" *ngIf="studyVM.study.industryId === studyVM.otherIndustryId">
    <label for="disp-other">Other</label>
    <span class="actualdata">{{ studyVM.study.industryOther }}</span>
  </div>
</div>

<hr />
<div class="title">Tested Party Business Description</div>
<div class="row">
  <div class="col-12">
    <label for="disp-prod">Business Description</label>
    <span class="actualdata line-break">{{ studyVM.study.businessDescription }}</span>
  </div>
</div>
